module.exports = __webpack_public_path__ + "static/img/image_j_wildberry.9eb0242.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_j_wildberry.jpg
// module id = ljeS
// module chunks = 1